import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'

import { SharedUiDobSelectModule } from '../lib/shared-ui-dob-select.module'
import { DobSelectDocsComponent } from './dob-select-docs/dob-select-docs.component'
import { AgeCheckDobSelectExampleComponent } from './dob-select-docs/examples/age-check-dob-select-example.component'
import { DobSelectExampleComponent } from './dob-select-docs/examples/dob-select-example.component'

@NgModule({
  declarations: [
    AgeCheckDobSelectExampleComponent,
    DobSelectDocsComponent,
    DobSelectExampleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule,
    SharedUiDobSelectModule
  ],
  exports: [
    DobSelectDocsComponent
  ]
})
export class SharedUiDobSelectDocsModule {}
